import React, { useEffect, useState } from "react";
import SingleCourseThree from "../../components/Course/SingleCourseThree";
import SectionTitle from "../../components/SectionTitle";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const CourseGridMain = () => {
  const [loading, setLoading] = useState(false);
  const [coursesData, setCoursesData] = useState([]);
  const [filteredTypes, setFilteredTypes] = useState([]);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/adult") {
      fetchCourses("Adult");
    } 
  }, [location.pathname]);

  const fetchCourses = async (category) => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/course`, {
        params: {
          type: category,
          page: 1,
          limit: 100,
        },
      });

      const fetchedCourses = response.data?.data?.currentDatas || [];
      if (fetchedCourses.length > 0) {
        setCoursesData(fetchedCourses);

        // Get unique types from fetched data and update state
        const types = fetchedCourses
          .map((item) => item.type)
          .filter((value, index, self) => self.indexOf(value) === index);
        setFilteredTypes(types);
      }
    } catch (err) {
      console.error(err);
      // Handle errors (could show a toast or error message)
    } finally {
      setLoading(false);
    }
  };

  // Render courses for a specific type (Adult, Kid, etc.)
  const renderCourses = (type) => {
    const filteredCourses = coursesData.filter(course => course.type === type);
    return filteredCourses.map((course, index) => (
     
      <div key={index} className="course-card">
        <SingleCourseThree
          course={course}
          
        
         
        />
      </div>
    ));
  };

  return (
    <div className="react-course-filter back__course__page_grid pb---40 pt---110">
     {
      !loading && (
        <div className="container pb---70">
        {filteredTypes.length===0 ?(
          <div className="course-message">
        <p className="no-courses">There are no avaliable courses.</p>
      </div>
        ) :(
          
          filteredTypes.map((type, index) => (
            <div key={index} className="row mb-5">
              <SectionTitle Title={`${type} Courses`} />
              <div className="course-card-container">
                {renderCourses(type)}
              </div>
            </div>
          ))
        )}
      </div>
      )
     }
    </div>
  );
};

export default CourseGridMain;
